import React, { useEffect, useState } from "react";
import API from "../../api/api";
import "../../style/credits.css";

export default function Credits() {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState("usage"); // usage | purchase
  const [loading, setLoading] = useState(true);

  const fetchCredits = async () => {
    try {
      setLoading(true);

      const res = await API.get(`/admin/credits?type=${filter}`);
      setData(res.data.data);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCredits();
  }, [filter]);

  return (
    <div className="admin-page credits-page">

      <h2 className="page-title">Credits Activity</h2>

      {/* 🔥 FILTER BUTTONS */}
      <div className="filter-bar">
        <button
          className={filter === "usage" ? "active" : ""}
          onClick={() => setFilter("usage")}
        >
          Usage
        </button>

        <button
          className={filter === "purchase" ? "active" : ""}
          onClick={() => setFilter("purchase")}
        >
          Purchases
        </button>
      </div>

      {loading ? (
        <div className="loader">Loading...</div>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>User</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Reason</th>
              <th>Balance</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {data.map(c => (
              <tr key={c._id}>
                <td>{c.userId?.name}</td>
                <td>{c.type}</td>
                <td>{c.amount}</td>
                <td>{c.reason}</td>
                <td>{c.balanceAfter}</td>
                <td>{new Date(c.createdAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

    </div>
  );
}